import { logger, LOGS } from "../../utils";
import { ApiManager } from "../api";
import {
    SttCorrectResponse,
    SttExtractFromEmailResponse,
    SttMailInput,
} from "./types/stt";

export class SttManager {
    // #region Properties

    private apiManager: ApiManager;

    // #endregion Properties

    // #region Constructor

    // Déviation volontaire : pas d'EventBus injecté (contrairement aux autres
    // managers). SttManager est un pass-through sans état ni événement à émettre.
    constructor(apiManager: ApiManager) {
        logger.info(LOGS.SttManager, "SttManager()");
        this.apiManager = apiManager;
    }

    // #endregion Constructor

    // #region Initialisation and cleanup

    public _cleanup(): Promise<void> {
        logger.info(LOGS.SttManager, "SttManager._cleanup()");
        return Promise.resolve();
    }

    // #endregion Initialisation and cleanup

    // #region Public methods

    public async correctText(
        text: string,
        contextTags?: string,
    ): Promise<SttCorrectResponse> {
        logger.info(LOGS.SttManager, "SttManager.correctText()");

        return this.apiManager.callSttCorrect(text, contextTags);
    }

    public async extractFromEmail(
        mail: SttMailInput,
    ): Promise<SttExtractFromEmailResponse> {
        logger.info(LOGS.SttManager, "SttManager.extractFromEmail()");

        return this.apiManager.callExtractFromEmail(mail);
    }

    // #endregion Public methods
}
